export default "__VITE_ASSET__bj0PyzSK__"